module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "feedback-knowledge-js": "static-1.5346",
      "hs-test-utils": "static-1.7928",
      "I18n": "static-7.1605",
      "jasmine-runner": "static-1.6383",
      "quartz": "static-1.6892",
      "hubspot-url-utils": "static-1.4064",
      "outpost": "static-1.4108",
      "PatternValidationJS": "static-1.437",
      "react": "static-7.184",
      "moment": "static-3.26",
      "foundations-components": "static-1.7764",
      "framer-motion": "static-1.70",
      "hs-test-utils-bend-plugin": "static-1.3039",
      "msw": "static-1.39",
      "react-dom": "static-7.85",
      "react-redux": "static-7.70",
      "redux": "static-4.16",
      "testing-library": "static-1.150",
      "enviro": "static-4.430",
      "i18n-data": "static-1.219",
      "metrics-js": "static-1.9558",
      "moment-timezone": "static-5.81",
      "react-utils": "static-2.5276",
      "StyleGuideUI": "static-3.485",
      "jasmine": "static-4.4239",
      "quartz-config": "static-1.670",
      "webpack-env": "static-1.54",
      "quartz-core": "static-1.6111",
      "csstype": "static-1.50",
      "bend-plugin-foundations-components": "static-1.4033",
      "floating-ui": "static-1.54",
      "foundations-assets": "static-1.4767",
      "foundations-theming": "static-1.4330",
      "foundations-theming-specialty": "static-1.2046",
      "hs-story-utils": "static-1.9345",
      "react-aria": "static-1.64",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.97",
      "styled-components": "static-2.88",
      "tanstack-table": "static-1.53",
      "trellis-assets": "static-1.1576",
      "ui-fonts": "static-1.637",
      "ui-images": "static-2.1132",
      "bender-build-tools": "static-1.3063",
      "hoist-non-react-statics": "static-3.9",
      "dispatcher": "static-1.134",
      "general-store": "static-6.20",
      "HeadJS": "static-2.736",
      "hub-http": "static-1.6136",
      "hub-http-janus": "static-1.820",
      "hubspotter-http": "static-1.4584",
      "icons": "static-2.639",
      "mobile-manifest-mixins": "static-1.510",
      "module-federation": "static-1.21",
      "PortalIdParser": "static-2.390",
      "quartz-auth": "static-1.567",
      "quartz-head": "static-1.557",
      "quartz-i18n": "static-1.567",
      "quartz-routing": "static-1.322",
      "quartz-test": "static-1.567",
      "quartz-tracking": "static-1.271",
      "quick-fetch": "static-1.3848",
      "raven": "static-3.5845",
      "raven-hubspot": "static-1.6152",
      "react-rhumb": "static-1.16574",
      "UIComponents": "static-3.8322",
      "usage-tracker-container": "static-1.7241",
      "usage-tracker-core": "static-1.7101",
      "bend-plugin-foundations-theming": "static-1.2813",
      "foundations-theming-base": "static-1.3315",
      "stylex": "static-1.30",
      "react-input-autosize": "static-2.17",
      "classnames": "static-2.10",
      "hs-locale-management": "static-1.17",
      "sassPrefix": "static-1.154",
      "hub-http-shared-msw-handlers": "static-1.9772",
      "hubspotter-http-shared-msw-handlers": "static-1.9770",
      "hs-promise-rejection-tracking": "static-1.5505",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "usage-tracker-session-replay": "static-1.4937",
      "cssUtils": "static-1.772",
      "head-dlb": "static-1.4938",
      "HubStyle": "static-2.11683",
      "HubStyleTokens": "static-2.11375",
      "ts-schema": "static-1.4010",
      "amplitude-session-replay-browser": "static-1.58"
    },
    "depPathPrefixes": {
      "feedback-knowledge-js": "/feedback-knowledge-js/static-1.5346",
      "hs-test-utils": "/hs-test-utils/static-1.7928",
      "I18n": "/I18n/static-7.1605",
      "jasmine-runner": "/jasmine-runner/static-1.6383",
      "quartz": "/quartz/static-1.6892",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4064",
      "outpost": "/outpost/static-1.4108",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react": "/react/static-7.184",
      "moment": "/moment/static-3.26",
      "foundations-components": "/foundations-components/static-1.7764",
      "framer-motion": "/framer-motion/static-1.70",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3039",
      "msw": "/msw/static-1.39",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.70",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.150",
      "enviro": "/enviro/static-4.430",
      "i18n-data": "/i18n-data/static-1.219",
      "metrics-js": "/metrics-js/static-1.9558",
      "moment-timezone": "/moment-timezone/static-5.81",
      "react-utils": "/react-utils/static-2.5276",
      "StyleGuideUI": "/StyleGuideUI/static-3.485",
      "jasmine": "/jasmine/static-4.4239",
      "quartz-config": "/quartz-config/static-1.670",
      "webpack-env": "/webpack-env/static-1.54",
      "quartz-core": "/quartz-core/static-1.6111",
      "csstype": "/csstype/static-1.50",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4033",
      "floating-ui": "/floating-ui/static-1.54",
      "foundations-assets": "/foundations-assets/static-1.4767",
      "foundations-theming": "/foundations-theming/static-1.4330",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2046",
      "hs-story-utils": "/hs-story-utils/static-1.9345",
      "react-aria": "/react-aria/static-1.64",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.97",
      "styled-components": "/styled-components/static-2.88",
      "tanstack-table": "/tanstack-table/static-1.53",
      "trellis-assets": "/trellis-assets/static-1.1576",
      "ui-fonts": "/ui-fonts/static-1.637",
      "ui-images": "/ui-images/static-2.1132",
      "bender-build-tools": "/bender-build-tools/static-1.3063",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "dispatcher": "/dispatcher/static-1.134",
      "general-store": "/general-store/static-6.20",
      "HeadJS": "/HeadJS/static-2.736",
      "hub-http": "/hub-http/static-1.6136",
      "hub-http-janus": "/hub-http-janus/static-1.820",
      "hubspotter-http": "/hubspotter-http/static-1.4584",
      "icons": "/icons/static-2.639",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.510",
      "module-federation": "/module-federation/static-1.21",
      "PortalIdParser": "/PortalIdParser/static-2.390",
      "quartz-auth": "/quartz-auth/static-1.567",
      "quartz-head": "/quartz-head/static-1.557",
      "quartz-i18n": "/quartz-i18n/static-1.567",
      "quartz-routing": "/quartz-routing/static-1.322",
      "quartz-test": "/quartz-test/static-1.567",
      "quartz-tracking": "/quartz-tracking/static-1.271",
      "quick-fetch": "/quick-fetch/static-1.3848",
      "raven": "/raven/static-3.5845",
      "raven-hubspot": "/raven-hubspot/static-1.6152",
      "react-rhumb": "/react-rhumb/static-1.16574",
      "UIComponents": "/UIComponents/static-3.8322",
      "usage-tracker-container": "/usage-tracker-container/static-1.7241",
      "usage-tracker-core": "/usage-tracker-core/static-1.7101",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2813",
      "foundations-theming-base": "/foundations-theming-base/static-1.3315",
      "stylex": "/stylex/static-1.30",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "classnames": "/classnames/static-2.10",
      "hs-locale-management": "/hs-locale-management/static-1.17",
      "sassPrefix": "/sassPrefix/static-1.154",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9772",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9770",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5505",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4937",
      "cssUtils": "/cssUtils/static-1.772",
      "head-dlb": "/head-dlb/static-1.4938",
      "HubStyle": "/HubStyle/static-2.11683",
      "HubStyleTokens": "/HubStyleTokens/static-2.11375",
      "ts-schema": "/ts-schema/static-1.4010",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58"
    },
    "bundlingPackage": "feedback-knowledge-js",
    "bundlingPackageVersion": "static-1.5346",
    "project": "feedback-knowledge-js",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};